import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["schoolSelect", "complexSelect", "schoolInput", "complexInput"]

  connect() {
    // Initialize visibility based on current radio selection
    const checkedRadio = this.element.querySelector('input[name="subscribable_type"]:checked')
    if (checkedRadio) {
      this.updateVisibility(checkedRadio.value)
    }
  }

  toggleSubscriber(event) {
    this.updateVisibility(event.target.value)
  }

  updateVisibility(value) {
    if (value === "School") {
      this.showSchool()
      this.hideComplex()
    } else {
      this.hideSchool()
      this.showComplex()
    }
  }

  showSchool() {
    this.schoolSelectTarget.classList.remove("hidden")
    if (this.hasSchoolInputTarget) {
      this.schoolInputTarget.disabled = false
      this.schoolInputTarget.name = "subscribable_id"
    }
  }

  hideSchool() {
    this.schoolSelectTarget.classList.add("hidden")
    if (this.hasSchoolInputTarget) {
      this.schoolInputTarget.disabled = true
      this.schoolInputTarget.name = ""
      this.schoolInputTarget.value = ""
      // Reset SlimSelect if exists
      if (this.schoolInputTarget.slim) {
        this.schoolInputTarget.slim.setSelected("")
      }
    }
  }

  showComplex() {
    this.complexSelectTarget.classList.remove("hidden")
    if (this.hasComplexInputTarget) {
      this.complexInputTarget.disabled = false
      this.complexInputTarget.name = "subscribable_id"
    }
  }

  hideComplex() {
    this.complexSelectTarget.classList.add("hidden")
    if (this.hasComplexInputTarget) {
      this.complexInputTarget.disabled = true
      this.complexInputTarget.name = ""
      this.complexInputTarget.value = ""
      // Reset SlimSelect if exists
      if (this.complexInputTarget.slim) {
        this.complexInputTarget.slim.setSelected("")
      }
    }
  }
}
